package com.raouf.mehrguard.web.i18n

internal val HebrewStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "גלאי QRishing ב-Kotlin Multiplatform",
    WebStringKey.MenuMain to "תפריט ראשי",
    WebStringKey.MenuSecurity to "אבטחה",
    WebStringKey.MenuSystem to "מערכת",
    WebStringKey.NavDashboard to "לוח בקרה",
    WebStringKey.NavScanMonitor to "מעקב סריקה",
    WebStringKey.NavScanHistory to "היסטוריית סריקות",
    WebStringKey.NavTrustCentre to "מרכז אמון",
    WebStringKey.NavReports to "דוחות",
    WebStringKey.NavTraining to "אימון",
    WebStringKey.NavSettings to "הגדרות",
    WebStringKey.QuickActions to "פעולות מהירות",
    WebStringKey.HeroTagline to "בטוח. לא מקוון.",
    WebStringKey.HeroTagline2 to "הגנה ניתנת להסבר.",
    WebStringKey.HeroDescription to "Mehr Guard מנתח איומים פוטנציאליים ישירות על החומרה שלך. חווה הגנה ללא השהייה.",
    WebStringKey.StartScan to "התחל סריקה חדשה",
    WebStringKey.ImportImage to "ייבא תמונה",
    WebStringKey.ScanQrCode to "סרוק קוד QR",
    WebStringKey.SystemHealth to "בריאות מערכת",
    WebStringKey.ThreatDatabase to "מאגר איומים",
    WebStringKey.Current to "נוכחי",
    WebStringKey.Active to "פעיל",
    WebStringKey.Threats to "איומים",
    WebStringKey.SafeScans to "סריקות בטוחות",
    WebStringKey.EngineActive to "מנוע פעיל",
    WebStringKey.EnterpriseProtection to "הגנה ארגונית פעילה",
    WebStringKey.SystemOptimal to "מערכת אופטימלית",
    WebStringKey.OfflineReady to "מוכן לעבודה לא מקוונת",
    WebStringKey.TrustCentreTitle to "מרכז אמון",
    WebStringKey.OfflineGuarantee to "ערובה לא-מקוונת מוחלטת",
    WebStringKey.ThreatSensitivity to "רגישות לאיומים",
    WebStringKey.Analyze to "נתח",
    WebStringKey.HeuristicEngine to "מנוע היוריסטי",
    WebStringKey.RecentScans to "סריקות אחרונות",
    WebStringKey.ViewFullHistory to "הצג היסטוריה מלאה",
    WebStringKey.Status to "סטטוס",
    WebStringKey.Source to "מקור",
    WebStringKey.Details to "פרטים",
    WebStringKey.Time to "זמן",
    WebStringKey.Version to "גרסה",
    WebStringKey.Signatures to "חתימות",
    WebStringKey.CheckForUpdates to "בדוק עדכונים",
    WebStringKey.NoScansYet to "אין סריקות עדיין. התחל סריקה חדשה כדי לראות תוצאות כאן.",
    WebStringKey.VerdictSafe to "בטוח",
    WebStringKey.VerdictPhish to "פישינג",
    WebStringKey.VerdictWarn to "אזהרה",
    WebStringKey.ActiveScanner to "סורק פעיל",
    WebStringKey.OfflineMode to "מצב לא מקוון",
    WebStringKey.CameraAccessRequired to "נדרשת גישה למצלמה",
    WebStringKey.EnableCamera to "אפשר מצלמה",
    WebStringKey.Scanning to "סורק...",
    WebStringKey.Torch to "פנס",
    WebStringKey.Gallery to "גלריה",
    WebStringKey.PasteUrl to "הדבק קישור",
    WebStringKey.AnalyzeUrl to "נתח קישור",
    WebStringKey.SystemStatus to "סטטוס מערכת",
    WebStringKey.PhishingEngine to "מנוע פישינג",
    WebStringKey.Ready to "מוכן",
    WebStringKey.Latency to "השהייה",
    WebStringKey.ViewAll to "הצג הכל",
    WebStringKey.VerdictHighRisk to "זוהה סיכון גבוה",
    WebStringKey.VerdictDangerous to "מסוכן",
    WebStringKey.ThreatConfidence to "ביטחון באיום",
    WebStringKey.ClearHistory to "נקה הכל",
    WebStringKey.ActionBlock to "חסום ודווח",
    WebStringKey.ActionQuarantine to "בידוד ב-Sandbox",
    WebStringKey.ExplainableSecurity to "אבטחה ניתנת להסבר",
    WebStringKey.UrlBreakdown to "פירוט קישור",
    WebStringKey.FullUrl to "קישור מלא",
    WebStringKey.OpenInBrowser to "פתח בדפדפן (מסוכן)",
    WebStringKey.RestrictedMode to "מצב מוגבל",
    WebStringKey.CopyUrl to "העתק קישור",
    WebStringKey.Share to "שתף",
    WebStringKey.Dismiss to "סגור",
    WebStringKey.ScanComplete to "הסריקה הושלמה",
    WebStringKey.Loading to "טוען...",
    WebStringKey.AnalyzedOffline to "נותח לא מקוון בפחות מ-5ms",
    WebStringKey.NoDataLeaves to "שום נתונים לא עוזבים את המכשיר",
    WebStringKey.ConfidenceScore to "ציון ביטחון",
    WebStringKey.RiskAssessment to "הערכת סיכונים",
    WebStringKey.AnalysisTime to "זמן ניתוח",
    WebStringKey.Heuristics to "היוריסטיקה",
    WebStringKey.TopAnalysisFactors to "גורמי ניתוח מובילים",
    WebStringKey.Pass to "עבר",
    WebStringKey.Clean to "נקי",
    WebStringKey.BackToDashboard to "חזרה ללוח הבקרה",
    WebStringKey.ShareReport to "שתף דוח",
    WebStringKey.CopyLink to "העתק קישור",
    WebStringKey.LinkCopied to "הקישור הועתק ללוח!",
    WebStringKey.BeatTheBot to "נצח את הבוט",
    WebStringKey.EndSession to "סיים מפגש",
    WebStringKey.Round to "סיבוב",
    WebStringKey.MakeDecision to "קבל החלטה",
    WebStringKey.Phishing to "פישינג",
    WebStringKey.Legitimate to "לגיטימי",
    WebStringKey.LiveScoreboard to "לוח תוצאות חי",
    WebStringKey.You to "אתה",
    WebStringKey.Points to "נקודות",
    WebStringKey.Streak to "רצף",
    WebStringKey.Accuracy to "דיוק",
    WebStringKey.Confidence to "ביטחון",
    WebStringKey.CorrectDecision to "החלטה נכונה!",
    WebStringKey.Correct to "נכון!",
    WebStringKey.NextRound to "סיבוב הבא",
    WebStringKey.GameOver to "המשחק נגמר!",
    WebStringKey.FinalResults to "תוצאות סופיות",
    WebStringKey.YourScore to "הציון שלך",
    WebStringKey.BotScore to "ציון הבוט",
    WebStringKey.BestStreak to "רצף הכי טוב",
    WebStringKey.PlayAgain to "שחק שוב",
    WebStringKey.ReturnToDashboard to "חזור ללוח הבקרה",
    WebStringKey.ExportSecurityReport to "ייצא דוח אבטחה",
    WebStringKey.ReportFormat to "פורמט דוח",
    WebStringKey.Last7Days to "7 ימים אחרונים",
    WebStringKey.Last30Days to "30 ימים אחרונים",
    WebStringKey.AllTime to "כל הזמנים",
    WebStringKey.GenerateExport to "ייצא דוח",
    WebStringKey.Success to "הצלחה!",
    WebStringKey.Error to "שגיאה",
    WebStringKey.Warning to "אזהרה",
    WebStringKey.CopiedToClipboard to "הועתק ללוח",
    WebStringKey.Cancel to "ביטול",
    WebStringKey.Confirm to "אישור",
    WebStringKey.Save to "שמור",
    WebStringKey.Delete to "מחק",
    WebStringKey.Edit to "ערוך",
    WebStringKey.Close to "סגור",
    WebStringKey.Back to "חזרה",
    WebStringKey.Next to "הבא",
    WebStringKey.Search to "חיפוש",
    WebStringKey.Filter to "סינון",
    WebStringKey.Sort to "מיון",
    WebStringKey.Scan to "סריקה",
    WebStringKey.Result to "תוצאה",
    WebStringKey.Copy to "העתק",
    WebStringKey.LivePreview to "תצוגה מקדימה חיה",
    WebStringKey.Verdict to "פסיקה",
    WebStringKey.RiskScore to "ציון סיכון",
    WebStringKey.TargetUrl to "קישור יעד",
    WebStringKey.AllowList to "רשימה מותרת",
    WebStringKey.BlockList to "רשימת חסימה",
    WebStringKey.AddDomain to "הוסף דומיין",
    WebStringKey.TrustedDomains to "דומיינים מהימנים",
    WebStringKey.BlockedDomains to "דומיינים חסומים",
    WebStringKey.Safe to "בטוח",
    WebStringKey.Suspicious to "חשוד",
    WebStringKey.Critical to "קריטי",
    WebStringKey.PhishingDetectionSensitivity to "רגישות זיהוי פישינג",
    WebStringKey.SensitivityLow to "נמוכה",
    WebStringKey.SensitivityBalanced to "מאוזנת",
    WebStringKey.SensitivityParanoia to "פרנויה",
    WebStringKey.PrivacyControls to "בקרות פרטיות",
    WebStringKey.StrictOfflineMode to "מצב לא-מקוון מחמיר",
    WebStringKey.AnonymousTelemetry to "טלמטריה אנונימית",
    WebStringKey.AutoCopySafeLinks to "העתק אוטומטית קישורים בטוחים",
    WebStringKey.PrivacyPolicy to "מדיניות פרטיות",
    WebStringKey.ResetAllSettings to "אפס את כל ההגדרות לברירת מחדל",
    WebStringKey.AddToAllowlist to "הוסף לרשימה המותרת",
    WebStringKey.AddToBlocklist to "הוסף לרשימת החסימה",
    WebStringKey.OnDeviceAnalysis to "ניתוח על המכשיר",
    WebStringKey.NoCloudLogs to "ללא יומני ענן",
    WebStringKey.OnDeviceDB to "מאגר נתונים על המכשיר",
    WebStringKey.SecurityAuditPass to "בדיקת אבטחה: עבר",
    WebStringKey.Support to "תמיכה",
    WebStringKey.Terms to "תנאים",
    WebStringKey.SystemsOperational to "מערכות פועלות",
    WebStringKey.SystemSecure to "מערכת מאובטחת",
    WebStringKey.KeyboardShortcuts to "קיצורי מקלדת",
    WebStringKey.StartScanner to "התחל סורק",
    WebStringKey.CloseMenuModal to "סגור תפריט / חלון",
    WebStringKey.NavigateToDashboard to "נווט ללוח בקרה",
    WebStringKey.NavigateToHistory to "היסטוריית סריקות",
    WebStringKey.NavigateToTrust to "מרכז אמון / רשימה מותרת",
    WebStringKey.NavigateToGame to "משחק נצח את הבוט",
    WebStringKey.ShowHelp to "הצג עזרה",
    WebStringKey.GotIt to "הבנתי",
    WebStringKey.SecuritySettings to "הגדרות אבטחה",
    WebStringKey.SensitivityLevel to "רמת רגישות",
    WebStringKey.AutoBlockThreats to "חסום איומים אוטומטית",
    WebStringKey.RealTimeScanning to "סריקה בזמן אמת",
    WebStringKey.SoundAlerts to "התראות קוליות",
    WebStringKey.ThreatAlerts to "התראות איומים",
    WebStringKey.ShowConfidenceScore to "הצג ציון ביטחון",
    WebStringKey.CompactView to "תצוגה קומפקטית",
    WebStringKey.ResetDefaults to "אפס לברירות מחדל",
    WebStringKey.SaveAndContinue to "שמור והמשך",
    WebStringKey.IncorrectDecision to "החלטה שגויה",
    WebStringKey.ResponseTime to "זמן תגובה",

    // Missing keys - Full Hebrew translations
    WebStringKey.AboutMehrGuard to "אודות Mehr Guard",
    WebStringKey.MehrGuardBot to "בוט Mehr Guard",
    WebStringKey.AccuracyPercent to "דיוק",
    WebStringKey.Acknowledgements to "תודות",
    WebStringKey.ActionBlockDesc to "מנע גישה והודע למנהל",
    WebStringKey.ActionQuarantineDesc to "פתח בבטחה לצורך ניתוח",
    WebStringKey.ActiveProtection to "הגנה פעילה",
    WebStringKey.AddManually to "הוסף ידנית",
    WebStringKey.AddToAllowlistTitle to "הוסף לרשימה המותרת",
    WebStringKey.AddToBlocklistTitle to "הוסף לרשימת החסימה",
    WebStringKey.AddedDaysAgo to "נוסף לפני 2 ימים",
    WebStringKey.AddedWeekAgo to "נוסף לפני שבוע",
    WebStringKey.AiNeuralAnalysis to "ניתוח נוירוני של AI",
    WebStringKey.AllSystemsOperational to "כל המערכות פעילות",
    WebStringKey.AnalysedOfflineTitle to "נותח לא מקוון.",
    WebStringKey.Analysis to "ניתוח",
    WebStringKey.AnalysisSummaryLabel to "סיכום הניתוח",
    WebStringKey.Analyzing to "מנתח...",
    WebStringKey.Arabic to "ערבית",
    WebStringKey.AttackHomographDesc to "זוהו תווים קיריליים המחקים את האלפבית הלטיני.",
    WebStringKey.AttackHomographExplain to "הדומיין משתמש ב-'а' קירילי (U+0430) במקום 'a' לטיני (U+0061). טכניקה זו משמשת בדרך כלל להטעיית משתמשים.",
    WebStringKey.AttackHomographTitle to "התקפת הומוגרף / IDN",
    WebStringKey.AttackJsDesc to "זוהתה מחרוזת אנטרופיה גבוהה בפרמטרים של URL.",
    WebStringKey.AttackJsTitle to "JavaScript מעורפל",
    WebStringKey.AttackPunycodeLabel to "Punycode אמיתי",
    WebStringKey.AttackRedirectDesc to "זוהו 3 קפיצות עם מקצרי URL ידועים.",
    WebStringKey.AttackRedirectTitle to "שרשרת הפניות חשודה",
    WebStringKey.AttackVisualLabel to "מראה חזותי",
    WebStringKey.BalancedModeDesc to "סורק דפוסים זדוניים ידועים. חוסם התקפות הומוגרף ושרשראות הפניה.",
    WebStringKey.LowSensitivityMode to "מצב רגישות נמוכה",
    WebStringKey.LowSensitivityModeDesc to "חוסם רק כתובות URL זדוניות מוכרות ממאגר האיומים. מינימום תוצאות חיוביות שגויות, אך עלול לפספס התקפות חדשות.",
    WebStringKey.ParanoiaMode to "מצב פרנויה",
    WebStringKey.ParanoiaModeDesc to "הגנה מרבית. חוסם כל דפוס חשוד כולל דומיינים שנרשמו לאחרונה, TLDs לא נפוצים וכל URL עם טריקי קידוד פוטנציאליים.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard משתמש במנועי ניתוח היוריסטיים מקומיים. אין נתוני תמונה, מחרוזות URL או מטא-נתונים שעוזבים מכשיר זה במהלך הסריקה. הפרטיות שלך מובטחת מתמטית.",
    WebStringKey.SignalBrandImpersonation to "זוהתה התחזות אפשרית למותג",
    WebStringKey.SignalCredentialParams to "פרמטרים הקשורים לאישורים ב-URL",
    WebStringKey.SignalEncodedPayload to "זוהו נתונים מקודדים בפרמטרי השאילתה",
    WebStringKey.SignalExcessiveSubdomains to "עומק תת-דומיין מוגזם ({count} רמות)",
    WebStringKey.SignalHighEntropyHost to "אקראיות גבוהה בשם הדומיין",
    WebStringKey.SignalHomographAttack to "הדומיין מכיל תווי הומוגרף/מבלבלים",
    WebStringKey.SignalHttpNotHttps to "משתמש בפרוטוקול HTTP לא מאובטח",
    WebStringKey.SignalIpAddressHost to "המארח הוא כתובת IP במקום דומיין",
    WebStringKey.SignalLongUrl to "URL ארוך באופן יוצא דופן ({length} תווים)",
    WebStringKey.SignalLongUrlMarketing to "URL ארוך באופן יוצא דופן ({length} תווים) - מכיל פרמטרי שיווק",
    WebStringKey.SignalNewlyRegisteredDomain to "זוהה דומיין שנרשם לאחרונה",
    WebStringKey.SignalNonStandardPort to "פורט לא סטנדרטי: {port}",
    WebStringKey.SignalNumericSubdomain to "זוהה תת-דומיין מספרי בלבד",
    WebStringKey.SignalSuspiciousPathKeywords to "מילות מפתח חשודות בנתיב ({count} נמצאו)",
    WebStringKey.SignalSuspiciousTld to "TLD חשוד: {tld}",
    WebStringKey.SignalUrlShortener to "משתמש בשירות קיצור URL",
    WebStringKey.BalancedModeRecommended to "מצב מאוזן (מומלץ)",
    WebStringKey.BeatTheBotAction to "נצח את הבוט →",
    WebStringKey.BeatTheBotDesc to "אתגר את מנוע ה-AI הלא מקוון שלנו. האם תוכל לזהות פישינג מהר יותר?",
    WebStringKey.BlacklistStatus to "סטטוס רשימה שחורה",
    WebStringKey.BlacklistStatusDesc to "לא נמצא ב-52 מאגרי איומים מקומיים.",
    WebStringKey.Brand to "מותג",
    WebStringKey.BreadcrumbHome to "בית",
    WebStringKey.BreadcrumbScans to "סריקות",
    WebStringKey.BrowserPreview to "תצוגה מקדימה בדפדפן",
    WebStringKey.CameraAccessDescription to "גרור תמונת קוד QR לכאן או אפשר גישה למצלמה.",
    WebStringKey.CertificateIssuer to "מנפיק האישור תואם לבעל הדומיין",
    WebStringKey.ChineseSimplified to "סינית (פשוטה)",
    WebStringKey.ChooseFormat to "בחר פורמט",
    WebStringKey.Clear to "נקה",
    WebStringKey.ComponentVoting to "הצבעת רכיבים",
    WebStringKey.ConfidencePercent to "ביטחון",
    WebStringKey.CopyTrustedUrls to "העתק כתובות URL מהימנות ללוח.",
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc. כל הזכויות שמורות.",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.CustomRange to "טווח מותאם אישית",
    WebStringKey.DangerousWarning to "כתובת URL זו סומנה כמסוכנת. פתיחתה עלולה לחשוף אותך לפישינג או תוכנות זדוניות.",
    WebStringKey.DataLifecycleVerification to "אימות מחזור חיי נתונים",
    WebStringKey.DateRange to "טווח תאריכים",
    WebStringKey.DetailLabel to "תווית פרט",
    WebStringKey.DetailValue to "ערך פרט",
    WebStringKey.Detected to "זוהה: ",
    WebStringKey.DisableExternalPreviews to "השבת את כל התצוגות המקדימות של קישורים חיצוניים.",
    WebStringKey.DomainAgeTrust to "גיל דומיין > 5 שנים (אמון גבוה)",
    WebStringKey.DomainPlaceholder to "הזן דומיין (לדוגמה: example.com)",
    WebStringKey.EducationalNote to "הערה חינוכית",
    WebStringKey.EngineStatus to "מנוע v2.4 • עודכן לפני 2 שעות",
    WebStringKey.English to "אנגלית",
    WebStringKey.EnterDomainPrompt to "הזן דומיין להוספה לרשימה",
    WebStringKey.EstablishedDomain to "דומיין מבוסס",
    WebStringKey.EstablishedDomainDesc to "דומיין נרשם לפני יותר מ-5 שנים. הסתברות נמוכה להונאה.",
    WebStringKey.ExecutiveSummary to "סיכום מנהלים",
    WebStringKey.Expected to "צפוי: ",
    WebStringKey.ExportInfoNote to "הייצוא כולל את כל וקטורי האיום שזוהו וניתוח עומס.",
    WebStringKey.ExportReport to "ייצא דוח",
    WebStringKey.ExportReportDesc to "צור דוח אבטחה בפורמט PDF או JSON",
    WebStringKey.FeatureExplainableDesc to "לא רק \"חסום\". אנו מספקים פירוט היוריסטי מפורט של פרמטרי URL והפניות.",
    WebStringKey.FeatureExplainableTitle to "אבטחה ניתנת להסבר",
    WebStringKey.FeatureOfflineDesc to "כל הניתוח מתבצע מקומית. הנתונים שלך לא עוזבים את המכשיר.",
    WebStringKey.FeatureOfflineTitle to "ארכיטקטורה לא מקוונת תחילה",
    WebStringKey.FeaturePerformanceDesc to "מותאם לסביבות שולחן עבודה. סריקות מעובדות בפחות מ-5ms.",
    WebStringKey.FlagHomograph to "התקפת הומוגרף",
    WebStringKey.FlagObfuscated to "סקריפט מעורפל",
    WebStringKey.FlagPhishing to "ניסיון פישינג",
    WebStringKey.French to "צרפתית",
    WebStringKey.GameEducationalNote to "הערה חינוכית",
    WebStringKey.GameHintTitle to "רמז למשחק",
    WebStringKey.GenerateReport to "צור דוחות אבטחה מקיפים מהיסטוריית הסריקות.",
    WebStringKey.German to "גרמנית",
    WebStringKey.Help to "עזרה",
    WebStringKey.Heuristic to "היוריסטיקה",
    WebStringKey.HighPerformanceEngine to "מנוע ביצועים גבוהים",
    WebStringKey.Hindi to "הינדי",
    WebStringKey.HoursAgo to "שעות לפני",
    WebStringKey.HumanReadable to "דוח קריא לאדם",
    WebStringKey.HumanReadableDesc to "PDF עם פירוט חזותי וסיכום מנהלים",
    WebStringKey.IdentifiedSafe to "זיהית נכון את ה-URL הבטוח.",
    WebStringKey.IncomingMessage to "הודעה נכנסת",
    WebStringKey.Indonesian to "אינדונזית",
    WebStringKey.Info to "מידע",
    WebStringKey.Italian to "איטלקית",
    WebStringKey.Japanese to "יפנית",
    WebStringKey.JsonFormatDesc to "פורמט JSON. הטוב ביותר לשילוב SIEM.",
    WebStringKey.Korean to "קוריאנית",
    WebStringKey.LastUpdate to "עדכון אחרון",
    WebStringKey.LatencyMs to "השהייה",
    WebStringKey.LearnHomograph to "למד לזהות התקפות הומוגרף מתקדמות ב-QR.",
    WebStringKey.LearnLocalArchitecture to "למד על הארכיטקטורה המקומית שלנו",
    WebStringKey.LiveFeedDisconnected to "הזנה חיה מנותקת",
    WebStringKey.LiveHint to "רמז חי",
    WebStringKey.LocalDb to "מאגר מקומי",
    WebStringKey.MLModel to "מודל ML",
    WebStringKey.MachineReadable to "נתונים קריאים למכונה",
    WebStringKey.MachineReadableDesc to "פורמט JSON לשילוב SIEM",
    WebStringKey.MetaEngine to "מנוע",
    WebStringKey.MetaOfflineGuaranteeDesc to "תמונה זו נותחה מקומית במכשיר שלך. לא נשלחו נתונים לענן.",
    WebStringKey.MetaOfflineGuaranteeLabel to "ערבות לא מקוונת:",
    WebStringKey.MetaSource to "מקור",
    WebStringKey.MetaTime to "זמן סריקה",
    WebStringKey.MinutesAgo to "דקות לפני",
    WebStringKey.NoCloudLogsDesc to "אנו משביתים בהחלט טלמטריה יוצאת לסריקות. התוצאות נשארות מקומיות.",
    WebStringKey.NoCustomDomainsBlocked to "אין דומיינים מותאמים חסומים.",
    WebStringKey.Notifications to "התראות",
    WebStringKey.OfflineDescription to "מאגר מקומי v2.4.1 פעיל. לא יוצאים נתונים מהמכשיר.",
    WebStringKey.OfflineGuaranteeDesc to "הניתוח של Mehr Guard פועל לחלוטין על המכשיר. נתוני URL לא עוזבים את הטלפון.",
    WebStringKey.OfflineProtection to "הגנה לא מקוונת",
    WebStringKey.OfflineSecurity to "אבטחה לא מקוונת",
    WebStringKey.OfflineSecurityDesc to "הנתונים שלך לא עוזבים את המכשיר. כל העיבוד מקומי.",
    WebStringKey.OnDeviceAnalysisDesc to "כל זיהוי האיומים פועל מקומית במכשיר. לא יוצאים נתונים.",
    WebStringKey.OnDeviceDBDesc to "מאגר חתימות האיומים הורד למכשיר לחיפושים במילישניות.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard מעבד כל סריקה באמצעות ניתוח מאובטח על המכשיר. אנו מתעדפים אבטחה ניתנת להסבר.",
    WebStringKey.OpenSourceLicenses to "רישיונות קוד פתוח",
    WebStringKey.OpenWarning to "פתיחת URL זה בדפדפן עלולה לחשוף אותך לסיכוני אבטחה.",
    WebStringKey.PasteUrlTitle to "הדבק URL לניתוח",
    WebStringKey.PdfFormatDesc to "פורמט PDF. הטוב ביותר לשיתוף.",
    WebStringKey.Portuguese to "פורטוגזית",
    WebStringKey.Previous to "קודם",
    WebStringKey.ProcessingResults to "מעבד תוצאות סריקה...",
    WebStringKey.Profile to "פרופיל",
    WebStringKey.ReadOnly to "קריאה בלבד",
    WebStringKey.ReasonAsn to "IP היעד נמצא ב-ASN בסיכון גבוה.",
    WebStringKey.ReasonDomainAge to "גיל הדומיין פחות מ-24 שעות.",
    WebStringKey.ReasonSignatures to "התאים ל-3 חתימות במאגר הפישינג המקומי.",
    WebStringKey.RedirectFinal to "יעד סופי",
    WebStringKey.RedirectHop to "קפיצת ביניים",
    WebStringKey.RedirectStart to "סריקת קוד QR",
    WebStringKey.RemoveDomain to "הסר דומיין",
    WebStringKey.ReportGeneration to "יצירת דוח",
    WebStringKey.ReportGenerationDesc to "הגדר פורמטים והורד את ניתוח האיומים.",
    WebStringKey.ReportSections to "חלקי הדוח",
    WebStringKey.Reset to "אפס",
    WebStringKey.ResetConfirm to "פעולה זו תאפס את כל הגדרות מרכז האמון לברירות המחדל.",
    WebStringKey.Response to "תגובה",
    WebStringKey.RestrictedDesc to "URL זה סומן כמסוכן פוטנציאלית. סקור את הניתוח לפני שתמשיך.",
    WebStringKey.RoundAnalysis to "ניתוח סיבוב",
    WebStringKey.Russian to "רוסית",
    WebStringKey.SafeUrlList to "רשימת URL בטוחים",
    WebStringKey.SampleUserName to "יוחנן כהן",
    WebStringKey.SampleUserRole to "אנליסט אבטחה",
    WebStringKey.ScanHint to "החזק יציב. מנותח לא מקוון בפחות מ-5ms.",
    WebStringKey.ScanTimeline to "ציר זמן סריקות",
    WebStringKey.ScanURLToSeeResults to "סרוק URL כדי לראות תוצאות מפורטות.",
    WebStringKey.ScoreLabel to "ציון:",
    WebStringKey.SectionActions to "פעולות מומלצות",
    WebStringKey.SectionAttackBreakdown to "פירוט התקפה",
    WebStringKey.SectionMeta to "מטא-נתוני סריקה",
    WebStringKey.SectionOverview to "סקירה",
    WebStringKey.SectionReports to "דוחות",
    WebStringKey.SectionSecurity to "אבטחה",
    WebStringKey.SectionTraining to "אימון",
    WebStringKey.SecureEnvironment to "סביבה מאובטחת",
    WebStringKey.SensitivityDescription to "התאם סף היוריסטי. רגישות גבוהה יותר עשויה להגביר התראות שווא.",
    WebStringKey.SessionId to "מזהה מפגש",
    WebStringKey.ShareDetectionStats to "שתף סטטיסטיקות זיהוי לשיפור ML.",
    WebStringKey.Spanish to "ספרדית",
    WebStringKey.SpottedPhishing to "זיהית נכון את URL הפישינג.",
    WebStringKey.SslCertificateDesc to "אישור הונפק על ידי DigiCert Inc. ללא חריגות בשרשרת האמון.",
    WebStringKey.StreakFire to "רצף",
    WebStringKey.Submit to "שלח",
    WebStringKey.TLD to "TLD",
    WebStringKey.TechnicalIndicators to "מדדים טכניים",
    WebStringKey.Thai to "תאילנדית",
    WebStringKey.ThreatAnalysisReport to "דוח ניתוח איומים",
    WebStringKey.ThreatBreakdown to "פירוט איומים",
    WebStringKey.ThreatMonitor to "מוניטור איומים",
    WebStringKey.ThreatMonitorDesc to "צפה באיומים חיים והפעל ביקורת אבטחה",
    WebStringKey.ThreatsBlocked to "איומים נחסמו",
    WebStringKey.TimeAgo to "לפני",
    WebStringKey.ToggleLightDarkMode to "החלף מצב בהיר/כהה",
    WebStringKey.ToggleMenu to "החלף תפריט",
    WebStringKey.ToggleTheme to "החלף ערכת נושא",
    WebStringKey.TrainingCentre to "מרכז אימון",
    WebStringKey.TrustCentreDesc to "הגדרות פרטיות ורגישות איומים",
    WebStringKey.Turkish to "טורקית",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.UrlInputPlaceholder to "הדבק URL לניתוח (לדוגמה: https://example.com)",
    WebStringKey.ValidSslCertificate to "אישור SSL תקף",
    WebStringKey.VerdictDangerousDesc to "קוד ה-QR מכיל מדדים זדוניים הקשורים לפישינג וגניבת אישורים.",
    WebStringKey.VerifiedBy to "אומת על ידי Mehr Guard Enterprise",
    WebStringKey.VersionStatus to "v2.4.1 • מערכת מאובטחת",
    WebStringKey.Vietnamese to "וייטנאמית",
    WebStringKey.VotingExplanation to "הצבעת רוב קובעת: 3+ בטוח = ירוק, 2+ זדוני = אדום",
    WebStringKey.VsMode to "מצב VS",
    WebStringKey.WaitingForAnalysis to "ממתין לניתוח...",
    WebStringKey.WaitingForScan to "ממתין לסריקה...",
    WebStringKey.Warn to "אזהרה",
    WebStringKey.WhitelistedRank to "דירוג Alexa Top 1k ברשימה לבנה מקומית",
    WebStringKey.WhyBotFlagged to "למה הבוט סימן",
    WebStringKey.WrongAnswer to "אופס! זה לא היה נכון.",
    WebStringKey.YourDataStaysOnDevice to "הנתונים שלך נשארים במכשיר.",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "אודות Mehr Guard Security",
    WebStringKey.ActualDomain to "הדומיין האמיתי",
    WebStringKey.AnalysisComplete to "הניתוח הושלם",
    WebStringKey.AutoBlockThreatsDesc to "חסום איומים אוטומטית",
    WebStringKey.AwaitingScanLabel to "ממתין לסריקה",
    WebStringKey.BrandImpersonation to "התחזות למותג",
    WebStringKey.CautionAdvised to "מומלצת זהירות",
    WebStringKey.CompactViewDesc to "תצוגה קומפקטית",
    WebStringKey.DoNotVisit to "אל תבקר",
    WebStringKey.DoNotVisitDesc to "זוהה פישינג ברמת ביטחון גבוהה. כתובת URL זו מציגה מספר אינדיקטורים זדוניים.",
    WebStringKey.DomainUsesInternationalChars to "דומיין זה משתמש בתווים בינלאומיים שעלולים לחקות דומיינים לגיטימיים.",
    WebStringKey.GoToScanner to "עבור לסורק",
    WebStringKey.Hebrew to "עברית",
    WebStringKey.HelpKeyboardShortcuts to "קיצורי מקלדת",
    WebStringKey.HeuristicAnalysis to "ניתוח היוריסטי",
    WebStringKey.HeuristicAnalysisDesc to "כתובת URL סומנה על סמך מספר גורמי סיכון שזוהו על ידי מנוע הניתוח.",
    WebStringKey.HiddenDestination to "יעד מוסתר",
    WebStringKey.HighRisk to "סיכון גבוה",
    WebStringKey.HighRiskLabel to "סיכון גבוה",
    WebStringKey.HomographIdnAttack to "התקפת הומוגרף / IDN",
    WebStringKey.InternationalizedDomainDetected to "זוהה שם דומיין בינלאומי.",
    WebStringKey.JustNow to "הרגע",
    WebStringKey.KeyboardShortcutsDesc to "קיצורי מקלדת לגישה מהירה",
    WebStringKey.LiveFeedActive to "פיד חי פעיל",
    WebStringKey.LowRisk to "סיכון נמוך",
    WebStringKey.LowRiskLabel to "סיכון נמוך",
    WebStringKey.Malicious to "זדוני",
    WebStringKey.MediumRiskLabel to "סיכון בינוני",
    WebStringKey.NoData to "אין נתונים",
    WebStringKey.NoScanDataResults to "אין נתוני סריקה זמינים. אנא סרוק כתובת URL כדי לראות תוצאות ניתוח.",
    WebStringKey.NoUrlScanned to "לא נסרקה כתובת URL",
    WebStringKey.Persian to "פרסית",
    WebStringKey.PhishingIndicators to "אינדיקטורים לפישינג",
    WebStringKey.ProceedWithCaution to "המשך בזהירות",
    WebStringKey.ProceedWithCautionDesc to "זוהו כמה אינדיקטורים חשודים. אמת את המקור לפני הזנת מידע רגיש.",
    WebStringKey.RealTimeScanningDesc to "סריקה בזמן אמת",
    WebStringKey.RedirectShortenerDetected to "זוהה הפניה/מקצר",
    WebStringKey.SafeToVisit to "בטוח לביקור",
    WebStringKey.SafeToVisitDesc to "אומת על ידי היוריסטיקה מקומית v2.4. לא נמצאו דפוסי פישינג, סקריפטים מוסתרים או התאמות לרשימה שחורה.",
    WebStringKey.SafetyScore to "ציון בטיחות",
    WebStringKey.ScanCompleteLabel to "הסריקה הושלמה",
    WebStringKey.ScanToAnalyze to "סרוק קוד QR או הזן כתובת URL לניתוח.",
    WebStringKey.ScannedURLLabel to "כתובת URL שנסרקה",
    WebStringKey.SecuritySignal to "אות אבטחה",
    WebStringKey.SensitivityLevelDesc to "רמת רגישות",
    WebStringKey.SensitivityPermissive to "מתירני",
    WebStringKey.SensitivityStrict to "קפדני",
    WebStringKey.SettingsDetection to "זיהוי",
    WebStringKey.SettingsDisplay to "תצוגה",
    WebStringKey.SettingsLanguage to "שפה",
    WebStringKey.SettingsLanguageDesc to "בחר שפת ממשק",
    WebStringKey.SettingsNotifications to "התראות",
    WebStringKey.SettingsSavedAutomatically to "ההגדרות נשמרות אוטומטית ומסונכרנות בין הפעלות.",
    WebStringKey.ShowConfidenceScoreDesc to "הצג ציון ביטחון",
    WebStringKey.SoundAlertsDesc to "התראות קוליות",
    WebStringKey.SuspiciousDomain to "דומיין חשוד",
    WebStringKey.SuspiciousEncoding to "קידוד חשוד",
    WebStringKey.SuspiciousKeywords to "מילות מפתח חשודות",
    WebStringKey.SuspiciousTld to "TLD חשוד",
    WebStringKey.SuspiciousTldDesc to "הדומיין משתמש ב-{tld} TLD שמקושר בדרך כלל לאתרים זדוניים.",
    WebStringKey.SuspiciousUrlParams to "פרמטרי URL חשודים",
    WebStringKey.SuspiciousUrlParamsDesc to "כתובת ה-URL מכילה פרמטרים מורכבים או מוסתרים פוטנציאלית.",
    WebStringKey.ThreatAlertsDesc to "התראות איומים",
    WebStringKey.ThreatDetected to "זוהה איום",
    WebStringKey.UnableToDetermine to "לא ניתן לקבוע פסק דין. אנא נסה שוב.",
    WebStringKey.Unknown to "לא ידוע",
    WebStringKey.UnknownURL to "כתובת URL לא ידועה",
    WebStringKey.UrlShortenerDesc to "כתובת ה-URL משתמשת בשירות קיצור שמסתיר את היעד הסופי.",
    WebStringKey.UrlShortenerDetected to "זוהה מקצר URL",
    WebStringKey.VersionOfflineReady to "מוכן לעבודה לא מקוונת",
    WebStringKey.VisualAppearance to "מראה חזותי",
    WebStringKey.WaitingForAnalysisLabel to "ממתין לניתוח...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "זוהתה סכמת JavaScript URL - מריצה קוד בעת לחיצה",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "זוהתה סכמת Data URI - עלולה להכיל קוד זדוני מוטבע",
    WebStringKey.ReasonAtSymbolInjectionTitle to "הזרקת סימן @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "כתובת ה-URL מכילה סימן @ המעיד על ניסיון אפשרי לגניבת אישורים",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "התקפת הומוגרף",
    WebStringKey.ReasonHomographDesc to "שם דומיין בינלאומי (IDN) עלול להתחזות לדומיין אחר",
    WebStringKey.ReasonMixedScriptTitle to "סקריפט מעורב",
    WebStringKey.ReasonMixedScriptDesc to "שם המארח מכיל תווים ממספר סקריפטים (התחזות אפשרית)",
    WebStringKey.ReasonLookalikeCharsTitle to "תווים דומים",
    WebStringKey.ReasonLookalikeCharsDesc to "הדומיין מכיל תווי Unicode שנראים כמו אותיות ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "תווים ברוחב אפס",
    WebStringKey.ReasonZeroWidthCharsDesc to "זוהו תווי Unicode נסתרים ברוחב אפס (ניסיון הסוואה)",
    WebStringKey.ReasonIpHostTitle to "מארח IP",
    WebStringKey.ReasonIpHostDesc to "כתובת ה-URL משתמשת בכתובת IP במקום שם דומיין",
    WebStringKey.ReasonCredentialParamTitle to "פרמטר אישורים",
    WebStringKey.ReasonCredentialParamDesc to "כתובת ה-URL מכילה פרמטרים הקשורים לאישורים (סיסמה, טוקן וכו')",
    WebStringKey.ReasonBrandImpersonationTitle to "התחזות למותג",
    WebStringKey.ReasonBrandImpersonationDesc to "נראה שכתובת ה-URL מתחזה למותג מוכר",
    WebStringKey.ReasonBrandInSubdomainTitle to "מותג בתת-דומיין",
    WebStringKey.ReasonBrandInSubdomainDesc to "שם המותג מופיע בתת-דומיין אך לא בדומיין הראשי",
    WebStringKey.ReasonRiskyExtensionTitle to "סיומת מסוכנת",
    WebStringKey.ReasonRiskyExtensionDesc to "הנתיב מכיל סיומת קובץ שעלולה להיות מסוכנת",
    WebStringKey.ReasonDoubleExtensionTitle to "סיומת כפולה",
    WebStringKey.ReasonDoubleExtensionDesc to "זוהתה סיומת קובץ כפולה (טקטיקה נפוצה של תוכנות זדוניות)",
    WebStringKey.ReasonEncodedPayloadTitle to "עומס מקודד",
    WebStringKey.ReasonEncodedPayloadDesc to "זוהה נתונים מקודדים גדולים בפרמטרים של כתובת ה-URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP ולא HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "כתובת ה-URL משתמשת בפרוטוקול HTTP לא מאובטח במקום HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD חשוד",
    WebStringKey.ReasonSuspiciousTldDesc to "דומיין עליון משמש לעתים קרובות לפישינג",
    WebStringKey.ReasonHighEntropyHostTitle to "מארח אנטרופיה גבוהה",
    WebStringKey.ReasonHighEntropyHostDesc to "שם הדומיין נראה כמו שנוצר באופן אקראי",
    WebStringKey.ReasonRedirectParamTitle to "פרמטר הפניה",
    WebStringKey.ReasonRedirectParamDesc to "כתובת ה-URL מכילה פרמטר הפניה שעלול להוביל לאתר אחר",
    WebStringKey.ReasonDeepSubdomainTitle to "תת-דומיין עמוק",
    WebStringKey.ReasonDeepSubdomainDesc to "עומק תת-דומיין מוגזם (עלול להסתיר את הדומיין האמיתי)",
    WebStringKey.ReasonMultiTldTitle to "TLD מרובה",
    WebStringKey.ReasonMultiTldDesc to "מספר מקטעים דמויי TLD בשם הדומיין",
    WebStringKey.ReasonNumericSubdomainTitle to "תת-דומיין מספרי",
    WebStringKey.ReasonNumericSubdomainDesc to "זוהה תת-דומיין מספרי בלבד",
    WebStringKey.ReasonNonStandardPortTitle to "פורט לא סטנדרטי",
    WebStringKey.ReasonNonStandardPortDesc to "כתובת ה-URL משתמשת במספר פורט לא סטנדרטי",
    WebStringKey.ReasonSuspiciousPortTitle to "פורט חשוד",
    WebStringKey.ReasonSuspiciousPortDesc to "כתובת ה-URL משתמשת בפורט המקושר בדרך כלל להתקפות",
    WebStringKey.ReasonFragmentHidingTitle to "הסתרת פרגמנט",
    WebStringKey.ReasonFragmentHidingDesc to "נראה שפרגמנט כתובת ה-URL מסתיר תוכן נוסף",
    WebStringKey.ReasonExcessiveEncodingTitle to "קידוד מוגזם",
    WebStringKey.ReasonExcessiveEncodingDesc to "זוהה קידוד URL מוגזם (ניסיון הסוואה)",
    WebStringKey.ReasonDomainAgePatternTitle to "דפוס גיל דומיין",
    WebStringKey.ReasonDomainAgePatternDesc to "שם הדומיין תואם לדפוסים של דומיינים שנוצרו אוטומטית",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "מקצר URL",
    WebStringKey.ReasonUrlShortenerDesc to "כתובת ה-URL משתמשת בשירות קיצור (מסתיר את היעד האמיתי)",
    WebStringKey.ReasonSuspiciousPathTitle to "נתיב חשוד",
    WebStringKey.ReasonSuspiciousPathDesc to "הנתיב מכיל מילות מפתח חשודות (login, verify וכו')",
    WebStringKey.ReasonLongUrlTitle to "URL ארוך",
    WebStringKey.ReasonLongUrlDesc to "כתובת URL ארוכה באופן חריג",
    WebStringKey.ReasonCredentialKeywordsTitle to "מילות מפתח אישורים",
    WebStringKey.ReasonCredentialKeywordsDesc to "כתובת ה-URL מכילה מילות מפתח לאיסוף אישורים",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL לא ניתן לניתוח",
    WebStringKey.ReasonUnparseableDesc to "לא ניתן היה לנתח את כתובת ה-URL במלואה",
    WebStringKey.ReasonAnalysisCompleteTitle to "הניתוח הושלם",
    WebStringKey.ReasonAnalysisCompleteDesc to "הניתוח הושלם בהצלחה",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "ציון פישינג ML",
    WebStringKey.MlCharacterAnalysis to "ניתוח תווים",
    WebStringKey.MlFeatureAnalysis to "ניתוח תכונות",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "דומיין IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "דומיין זה משתמש בתווים בינלאומיים. תצוגה בטוחה:",
    WebStringKey.MixedScriptAttackTitle to "מתקפת סקריפטים מעורבים",
    WebStringKey.MixedScriptAttackDesc to "הדומיין מכיל תווים ממספר כתבים (למשל קירילית + לטינית). נפוץ במתקפות הומוגרף.",
    WebStringKey.ConfusableCharsTitle to "תווים מבלבלים",
    WebStringKey.ConfusableCharsDesc to "הדומיין מכיל תווים הדומים לאותיות נפוצות (למשל 'а' לעומת 'a')."
)

internal val HebrewCommonStrings = mapOf(
    "Dashboard" to "לוח בקרה",
    "Settings" to "הגדרות",
    "Language" to "שפה",
    "Scan" to "סריקה",
    "Result" to "תוצאה",
    "Safe" to "בטוח",
    "Suspicious" to "חשוד",
    "Dangerous" to "מסוכן",
    "Phishing" to "פישינג",
    "Legitimate" to "לגיטימי",
    "Copy" to "העתק",
    "Share" to "שתף",
    "Close" to "סגור",
    "Cancel" to "ביטול",
    "Confirm" to "אישור",
    "Save" to "שמור",
    "Delete" to "מחק",
    "Back" to "חזרה",
    "Next" to "הבא",
    "Search" to "חיפוש",
    "Filter" to "סינון",
    "Sort" to "מיון",
    "Error" to "שגיאה",
    "Warning" to "אזהרה",
    "Success" to "הצלחה",
    "Loading" to "טוען...",
    "Active" to "פעיל",
    "Version" to "גרסה",
    "Export" to "ייצוא",
    "Import" to "ייבוא",
    "Report" to "דוח",
    "Analysis" to "ניתוח",
    "Security" to "אבטחה",
    "Privacy" to "פרטיות",
    "Help" to "עזרה",
    "About" to "אודות",
    "Hebrew" to "עברית",
    "Persian" to "פרסית",

    // Missing key sync
    WebStringKey.Last90Days to "90 הימים האחרונים",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "פעילות חשודה",
    WebStringKey.VerdictWarning to "אזהרה",
    WebStringKey.VerdictSuspiciousDesc to "קוד ה-QR הסרוק מציג דפוסים חשודים שעשויים להצביע על סיכוני אבטחה פוטנציאליים. המשך בזהירות.",
    WebStringKey.VerdictMinorConcerns to "חששות קלים",
    WebStringKey.VerdictCaution to "זהירות",
    WebStringKey.VerdictMinorConcernsDesc to "זוהו כמה חששות אבטחה קלים. הקישור נראה בטוח ברובו אך מומלץ לבדוק.",
    WebStringKey.VerdictVerifiedSafe to "מאומת בטוח",
    WebStringKey.VerdictSafeLabel to "בטוח",
    WebStringKey.VerdictVerifiedSafeDesc to "לא זוהו איומי אבטחה. קוד ה-QR מוביל ליעד בטוח מאומת.",
    WebStringKey.VerdictNoActivity to "אין פעילות",
    WebStringKey.VerdictAwaitingScan to "ממתין לסריקה",
    WebStringKey.VerdictNoActivityDesc to "אין נתוני סריקה זמינים. אנא סרוק קוד QR או הזן URL לניתוח.",
    WebStringKey.ScanQrToSeeActivity to "סרוק קוד QR כדי לראות את הפעילות שלך כאן",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "נקודת נתונים",
    WebStringKey.ProcessingEnv to "סביבת עיבוד",
    WebStringKey.ExternalTransmission to "שידור חיצוני",
    WebStringKey.RawImageBuffer to "חוצץ תמונה גולמי",
    WebStringKey.LocalMemoryRam to "זיכרון מקומי (RAM)",
    WebStringKey.TransmissionNone to "ללא",
    WebStringKey.DecodedUrlPayload to "URL/תוכן מפוענח",
    WebStringKey.LocalAnalysis to "ניתוח מקומי",
    WebStringKey.ThreatVerdictLabel to "פסק דין איום",
    WebStringKey.LocalDatabase to "מסד נתונים מקומי"
)
